import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const PaymentSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default PaymentSVG;
